export default __webpack_public_path__ + "static/media/file.d71e5020.svg";